import { atom } from "recoil";

// 確認画面のシミュレーション料金表示用
export const simulationAmountState = atom({
  key: "simulationAmountState",
  default: {
    loading: false,
    cource_type: null,
    funding_price: '',
    calc_price: '',
    result_price: '',
    message: '',
  },
});